import { CaseData } from 'app/types-shared';
import { parseAsDateUTC } from './date';

const getValue = values => values.reduce(
  (memo: string, fv) => {
    const date = parseAsDateUTC(fv.v);
    const value = (date && date.toLocaleDateString(undefined, {timeZone: 'UTC'})) || fv.d || fv.v;
    return memo + (memo.length ? ' ' : '') + value;
  }, '');

export const getField = (item, field) => item && item.fields && item.fields[field] && item.fields[field].values
  ? getValue(item.fields[field].values)
  : '';

/**
 * Receives the entity ID for the current wire JSON format
 */
export function primaryKey(entity: CaseData) : number {
  return entity.primaryKey && entity.primaryKey.v;
}

export function caseTypeId(entity: CaseData): number {
  return entity.caseType && entity.caseType.v;
}

export function caseContextId(entity: CaseData): number {
  return entity.caseContext && entity.caseContext.v;
}

export function caseNumber(entity: CaseData): number {
  return Number(getField(entity, 'CaseNo'));
}
